import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable()
export class DevApiKeyInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Klucz dev TYLKO do naszego API — nie wysyłaj go do żądań cross-origin
    // (np. geokoder nominatim), bo niestandardowy nagłówek wymusza preflight
    // CORS, który zewnętrzny serwer odrzuca → "Błąd CORS".
    if (environment.devApiKey && request.url.startsWith(environment.apiUrl)) {
      request = request.clone({
        setHeaders: {
          'X-Dev-Api-Key': environment.devApiKey
        }
      });
    }

    return next.handle(request);
  }
}
